import React, { useState, useEffect } from "react";
import { Box, Toolbar, useTheme, useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";

import Sidebar from "./DesktopSidebar";
import Navbar from "./DesktopNavbarComponets/Navbar";

const Layout = ({ children }) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isLoginPage = location.pathname === "/login";
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);

  // إغلاق Sidebar تلقائياً عند التبديل للموبايل
  useEffect(() => {
    setIsSidebarOpen(!isMobile);
  }, [isMobile]);

  const sidebarWidth = isSidebarOpen ? 250 : 60;
  const contentMargin = isLoginPage ? "0px" : isMobile ? "0px" : `${sidebarWidth}px`;

  return (
    <Box sx={{ display: "flex", direction: "rtl" }}>
      {!isLoginPage && <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} isMobile={isMobile} />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          transition: "margin 0.3s ease-in-out",
          marginRight: contentMargin,
          minHeight: "100vh",
          width: { xs: "100%", md: "auto" },
        }}
      >
        {!isLoginPage && <Navbar isSidebarOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />}
        {!isLoginPage && <Toolbar />}
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
